import React from "react";
import cn from "classnames";
import { Link } from "react-router-dom";
import styles from "./Hero.module.sass";
import ScrollButton from "../../../components/ScrollButton";
import Image from "../../../components/Image";
import ScrollParallax from "../../../components/ScrollParallax";

const Hero = ({ scrollToRef }) => {
  return (
    <div className={styles.hero}>
      <div className={cn("container", styles.container)}>
        <div className={styles.wrap}>
          <div className={cn("stage", styles.stage)}>
          Get Paid to Train
          </div>
          <h1 className={cn("h1", styles.title)}>
          Turn Your Fitness Regime into Revenue
          </h1>
          <div className={styles.text}>
          Expand your reach and rack up earnings as your followers sweat it out with you.
          </div>
          <div className={styles.btns}>
            <Link className={cn("button", styles.purpleButton)} to="/download">
              Download App
            </Link>
          </div>
        </div>
        <ScrollButton
          onScroll={() =>
            scrollToRef.current.scrollIntoView({ behavior: "smooth" })
          }
          className={styles.scroll}
        />
        <div className={styles.gallery}>
          <div className={styles.preview}>
            <Image
              srcSet="/images/content/5-5-influencer-screen.png "
              srcSetDark="/images/content/5-5-influencer-screen.png"
              src="//images/content/5-5-influencer-screen.png"
              srcDark="/images/content/5-5-influencer-screen.png"
              alt="Main"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
